export enum DropdownType {
  Button = 'Button',
  Default = 'Default'
}
